import type { ReactElement } from 'react';
import type { MonthCell } from '../../api/calendarTypes.js';
import { DayCell } from './DayCell.js';
import { weekdayHeadings } from './calendarUtils.js';

export interface MonthlyGridProps {
  cells: MonthCell[];
  onSelect: (iso: string) => void;
}

export function MonthlyGrid({ cells, onSelect }: MonthlyGridProps): ReactElement {
  const headings = weekdayHeadings();
  return (
    <div className="flex flex-col gap-1" data-testid="monthly-grid">
      <div
        className="grid grid-cols-7 gap-1 text-center text-[10px] uppercase"
        style={{ color: 'var(--text-muted)' }}
        data-testid="monthly-grid-headings"
      >
        {headings.map((h, i) => (
          <div key={`${h}-${i}`} className="py-1">
            {h}
          </div>
        ))}
      </div>
      <div
        className="grid grid-cols-7 gap-1"
        data-testid="monthly-grid-cells"
      >
        {cells.map((cell) => (
          <DayCell key={cell.iso} cell={cell} onSelect={onSelect} />
        ))}
      </div>
    </div>
  );
}
